import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { stakingTypes } from '../constants';

const StakingFilters = ({ onChangeType, selectedTab }) => {
  const { t: translate } = useTranslation();

  return (
    <div className="flex-row-center mx-2">
      <div className="col-12 col-md-6 rounded-4 flex-row-center bg-light border border-shadow ">
        <button
          type="button"
          style={{ height: '2.5rem' }}
          className={`toggle-item ${
            selectedTab === stakingTypes.ACTIVE && 'active'
          } btn w-50 py-2 px-4 rounded-4`}
          onClick={() => onChangeType(stakingTypes.ACTIVE)}>
          {translate('staking_active_tab')}
        </button>
        <button
          type="button"
          style={{ height: '2.5rem' }}
          className={`toggle-item ${
            selectedTab === stakingTypes.COMPLETED && 'active'
          } btn w-50 py-2 px-4 rounded-4 text-nowrap`}
          onClick={() => onChangeType(stakingTypes.COMPLETED)}>
          {translate('staking_completed_tab')}
        </button>
      </div>
    </div>
  );
};

export default StakingFilters;

StakingFilters.propTypes = {
  onChangeType: PropTypes.func.isRequired,
  selectedTab: PropTypes.string.isRequired,
};
